// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__ySj1d","name":"ConsentHeader_name__949wo","birthday":"ConsentHeader_birthday__3oiTd","skeleton":"ConsentHeader_skeleton__Tu6yy"};